"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_mail_messagead_list_store_1 = require("owa-mail-messagead-list-store");
var owa_mail_messagead_store_1 = require("owa-mail-messagead-store");
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.orchestrator(owa_mail_messagead_store_1.removeMessageAdClearList, function (actionMessage) {
    owa_mail_messagead_store_1.removeMessageAd(actionMessage.removeAdId);
    if (owa_mail_messagead_store_1.getStore().messageAdRowStore.size == 0) {
        owa_mail_messagead_list_store_1.removeMessageAdList();
    }
});
//# sourceMappingURL=removeMessageAdClearListOrchestrator.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/owa-mail-messagead-orchestration/lib/orchestrators/removeMessageAdClearListOrchestrator.js
// module id = 6008
// module chunks = 67